// Control Afterpay Text Styling
setTimeout(() => {
    const squarePlacement = document.querySelector('square-placement').shadowRoot;

    const afterpayTextElement = squarePlacement.querySelector('.afterpay-main-text');
    if (afterpayTextElement) {
        afterpayTextElement.style.fontSize = '12px';
        afterpayTextElement.style.marginRight = '5px';
        afterpayTextElement.style.color = '#222';
        afterpayTextElement.style.lineHeight = '14px';
        afterpayTextElement.style.fontWeight = '700';
    }

    const logoBadgeElement = squarePlacement.querySelector('.afterpay-logo.type-badge svg');
    if (logoBadgeElement) {
        logoBadgeElement.style.height = '30px';
        logoBadgeElement.style.position = 'relative';
        logoBadgeElement.style.left = '-10px';
        logoBadgeElement.style.top = '2px';
    }

    const afterpayButtonElement = squarePlacement.querySelector('button.afterpay-logo.brand-afterpay.type-badge.black-on-mint');
    if (afterpayButtonElement) {
        afterpayButtonElement.style.width = '85px';
    }
}, 1200);


// Account Login Slider
document.addEventListener('DOMContentLoaded', function() {
  // Get the elements
  const loginIcon = document.querySelector('.header__icon--account');
  const loginSlider = document.querySelector('.account-login-slider');
  const closeButton = document.querySelector('.account-login-slider .close-button');

  // Toggle slider on login icon click
  loginIcon.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default link action
    loginSlider.classList.toggle('active'); // Toggle the active class
  });

  // Close slider on close button click
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      loginSlider.classList.remove('active'); // Hide the slider
    });
  }

  // Close slider on clicking outside of it
  document.addEventListener('click', function(event) {
    if (!loginSlider.contains(event.target) && !loginIcon.contains(event.target)) {
      loginSlider.classList.remove('active'); // Hide the slider
    }
  });
});


// Sticky Add to Cart
document.addEventListener("DOMContentLoaded", function () {
  const productDescription = document.querySelector(".product-page .product__description");
  const productPageWithForm = document.querySelector(".product-page div:has(> .product-form)");

  if (productDescription && productPageWithForm) {
    const descriptionOffsetTop = productDescription.offsetTop;

    window.addEventListener("scroll", function () {
      if (window.scrollY >= descriptionOffsetTop) {
        productPageWithForm.classList.add("sticky-atc-after");
      } else {
        productPageWithForm.classList.remove("sticky-atc-after");
      }
    });
  }
});

window.addEventListener('scroll', function() {
    const button = document.querySelector('.product-page .product-form__buttons button:first-child');
    const stickyPosition = button.getBoundingClientRect().top + window.scrollY; // Get the button's initial sticky position
  
    if (window.scrollY < stickyPosition) {
        button.classList.add('sticky-full-width');
    } else {
        button.classList.remove('sticky-full-width');
    }

});

// let cloneAndAdjustPrice = () => {
//   let $container = $(".rc-template__radio");
//   if ($container.length) {
//     let $firstRadioLabel = $container.find("label.rc-radio").first();
//     if (
//       $firstRadioLabel.length &&
//       !$container.find(".rc-radio").hasClass("cloned")
//     ) {
//       let $clonedRadioLabel = $firstRadioLabel.clone(true).addClass("cloned");
//       let originalPriceText = $firstRadioLabel
//         .find(".rc-radio__label")
//         .text()
//         .match(/\$\d+\.\d{2}/);
//       if (originalPriceText) {
//         let $label = $clonedRadioLabel.find(".rc-radio__label");
//         $label.text($label.text().replace(originalPriceText[0], "").trim());
//         let $customPriceLayer = $(
//           '<span class="custom-price-layer"></span>'
//         ).text(originalPriceText[0]);
//         $label.append($customPriceLayer);
//       }
//       $clonedRadioLabel.insertAfter($firstRadioLabel);
//       $firstRadioLabel.hide();
//     }
//   }

//   $('body.product-page .rc-widget').fadeIn();
// };

// let updatePriceOnVariantChange = () => {
//   let $firstPriceText = $(".rc-template__radio label.rc-radio")
//     .first()
//     .find(".rc-radio__label")
//     .text();
//   let originalPriceText = $firstPriceText.match(/\$\d+\.\d{2}/);
//   if (originalPriceText) {
//     let newPrice = originalPriceText[0];
//     $(".rc-template__radio label.rc-radio.cloned")
//       .find(".custom-price-layer")
//       .text(newPrice);
//   }
// };

// let changeFunction = () => {
//   $(".product__info-container variant-selects input").change(function () {
//     setTimeout(() => {
//       console.log("poop");
//       updatePriceOnVariantChange();
//       changeFunction();
//     }, 400);
//   });
// };

function setInitialPrice() {
    var priceText = $(".onetime-radio > span").text().trim(); // Get the text content
    var price = priceText.match(/\$[\d,\.]+/); // Match the price pattern, e.g., "$69.00"
    if (price) {
        $(".onetime-radio > span").attr("data-price", `${price[0]} AUD`); // Set the data-price attribute
    }
}

function updatePriceOnVariantChange() {
    var priceText = $(".onetime-radio > span").text().trim(); // Get the new text content
    var price = priceText.match(/\$[\d,\.]+/); // Match the price pattern
    if (price) {
        $(".onetime-radio > span").attr("data-price", `${price[0]} AUD`); // Update the data-price attribute
    }
}

const quickAddButton = document.querySelector('.jci-faux-quick-add-button');
if (quickAddButton) {
    setTimeout(() => {
      quickAddButton.addEventListener('click', wrapPriceInSpan);
    }, 3000);
}

document.querySelector('.back-to-top-button').addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
});

// Function to generate star ratings based on rounded rating
function generateStars(rating, element) {
    const fullStar = '★';
    const emptyStar = '☆';
    let starsHtml = '';

    const roundedRating = Math.round(rating);

    for (let i = 1; i <= 5; i++) {
        starsHtml += i <= roundedRating ? fullStar : emptyStar;
    }

    element.innerHTML = starsHtml;
}

// Function to populate overall rating and initial reviews array
function populateReviews() {
    const overallRatingElement = document.querySelector('.jdgm-rev-widg__summary-average a');
    const ratingText = overallRatingElement.innerText.split(" ")[0];
    const rating = parseFloat(ratingText);
    const totalReviews = document.querySelector('.jdgm-rev-widg__summary-text').innerText.match(/\d+/)[0];

    // Populate the overall rating stars and review count once
    generateStars(rating, document.getElementById('overall-stars'));
    document.querySelector('.review-count').innerText = `${totalReviews} Reviews`;

    // Get review items from the widget and store in an array
    const reviewItems = document.querySelectorAll('.jdgm-rev');
    const reviewsArray = [];

    reviewItems.forEach((review) => {
        const reviewerName = review.querySelector('.jdgm-rev__author').innerText;
        const reviewContent = review.querySelector('.jdgm-rev__body').innerText;
        const reviewRating = parseInt(review.querySelector('.jdgm-rev__rating').getAttribute('data-score'), 10);

        reviewsArray.push({ reviewerName, reviewContent, reviewRating });
    });

    // Start cycling reviews
    displayReview(reviewsArray, 0);
}

// Function to display a single review with sliding animation
function displayReview(reviewsArray, index) {
    const reviewElement = document.querySelector('.jci-review-section .review');
    const profileElement = document.querySelector('.jci-review-section .review-profile .profile-icon');

    // Populate current review details with sliding animation
    const review = reviewsArray[index];
    reviewElement.classList.add('slide-up'); // Add animation class
    generateStars(review.reviewRating, document.getElementById('review-stars'));
    document.querySelector('.review-text').innerText = review.reviewContent;
    document.querySelector('.review-author').innerText = review.reviewerName;
    profileElement.innerText = review.reviewerName.charAt(0); // First initial for profile icon

    // Remove animation class after animation duration to reapply later
    setTimeout(() => {
        reviewElement.classList.remove('slide-up');
    }, 800);

    // Cycle to the next review
    const nextIndex = (index + 1) % reviewsArray.length;
    setTimeout(() => {
        displayReview(reviewsArray, nextIndex);
    }, 5000);
}

// Check if we are on a product page
const isProductPage = document.querySelector('.product-page');
if (isProductPage) {
    setTimeout(() => {
        populateReviews();

        // Add fade-in effect to .jci-review-section
        const reviewSection = document.querySelector('.jci-review-section');
        if (reviewSection) {
            reviewSection.style.display = 'block';
            setTimeout(() => {
                reviewSection.classList.add('show');
            }, 10);
        }
    }, 3000);
}









setTimeout(() => {
  
  jQuery(document).ready(function($) {

      let isProduct = $('body').hasClass('product-page');
    
      let runAccordion = () => {
        $('.accordion-content').slideDown(0);
  
        $('.accordion-title').on('click', function() {
            const accordionItem = $(this).parent();
            const accordionContent = $(this).next('.accordion-content');
            
            accordionContent.slideToggle(400);
            accordionItem.toggleClass('open');
        });
      }

      let styleAfterPay = () => {
        $('.afterpay-main-text').attr('style','font-size: 12px;margin-right: 5px;color: #222;line-height: 14px;font-weight: 700;');
      }

      if (isProduct) {
        runAccordion();
        styleAfterPay();

        setInitialPrice();
        $('body.product-page .rc-widget').fadeIn();
        $("body.product-page").on("change", ".product__info-container variant-selects input", function () {
            setTimeout(() => {
              updatePriceOnVariantChange();
            }, 400);
            console.log('poop')
        });
      }
    
  });
}, 3000);










